import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { EntityContentBlueprint } from '@backstage/plugin-catalog-react/alpha';

const repositoryPullRequestsContent = EntityContentBlueprint.make({
  name: 'repository-pull-requests',
  params: {
    path: 'pull-requests',
    title: 'Pull Requests',
    filter: 'kind:repository',
    loader: () =>
      import('@roadiehq/backstage-plugin-github-pull-requests').then(m => (
        <m.Router />
      )),
  },
});

export const githubPullRequestsModule = createFrontendModule({
  pluginId: 'catalog',
  extensions: [repositoryPullRequestsContent],
});
